import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexSlider',
  setup(__props) {

const SlidesOnly = defineAsyncComponent(() => import("@/components/theme/advance/slider/SlidesOnly.vue"))
const WithControls = defineAsyncComponent(() => import("@/components/theme/advance/slider/WithControls.vue"))
const AutoPlay = defineAsyncComponent(() => import("@/components/theme/advance/slider/AutoPlay.vue"))
const MouseWheel = defineAsyncComponent(() => import("@/components/theme/advance/slider/MouseWheel.vue"))
const WithIndicators = defineAsyncComponent(() => import("@/components/theme/advance/slider/WithIndicators.vue"))
const WithCaptions = defineAsyncComponent(() => import("@/components/theme/advance/slider/WithCaptions.vue"))
const CrossFade = defineAsyncComponent(() => import("@/components/theme/advance/slider/CrossFade.vue"))
const IndividualCarousel = defineAsyncComponent(() => import("@/components/theme/advance/slider/IndividualCarousel.vue"))
const DisableTouch = defineAsyncComponent(() => import("@/components/theme/advance/slider/DisableTouch.vue"))
const DarkVariant = defineAsyncComponent(() => import("@/components/theme/advance/slider/DarkVariant.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Bonus Ui",
      mains: "Slider",
      title: "Slider"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(SlidesOnly)),
        _createVNode(_unref(WithControls)),
        _createVNode(_unref(AutoPlay)),
        _createVNode(_unref(MouseWheel)),
        _createVNode(_unref(WithIndicators)),
        _createVNode(_unref(WithCaptions)),
        _createVNode(_unref(CrossFade)),
        _createVNode(_unref(IndividualCarousel)),
        _createVNode(_unref(DisableTouch)),
        _createVNode(_unref(DarkVariant))
      ])
    ])
  ], 64))
}
}

})